<template>
    <div class="infoscreen list" @click="$core.f().skip" v-if="$store.getters.authorized">
        <h1 class="headline">Mitglieder</h1>
        <div :class="'userlist'+( isAdmin ? ' is-admin' : '' )">
            <p class="marge-bottom"><strong>Hier</strong> findest Du eine Liste aller zur Zeit auf <Lovepod/> registrierten Nutzerinnen und Nutzer.
                Mit Hilfe unserer Filter kannst Du die Anzahl der angezeigten Profile reduzieren: Probiere es einfach mal aus.</p>
            <div v-for="(item, index) in list" :key="index" class="list-item marge-half-bottom">
                <div class="basic-info" @click="toggleInfo( item.id )">
                    <div class="username" :style="'color:#'+item.color+';'">
                        <Username :item="item" />
                    </div>
                    <div v-if="1 === item.level" class="pill member">
                        &nbsp;
                    </div>
                    <div v-if="5 === item.level" class="pill admin">
                        Support
                    </div>
                    <div v-if="4 === item.level" class="pill admin">
                        Dev
                    </div>
                    <div v-if="10 === item.level" class="pill webmaster">
                        Admin
                    </div>
                </div>
                <div class="timestamp">
                    <span class="timestamp" v-html="'letzter Login '+$core.getFriendlyTimestamp().friendlyTimestamp( item.datetimeLastLogin )"></span>
                </div>
                <transition-group appear name="slide-fade" mode="out-in">
                    <div v-if="isAdmin && -1 < open.indexOf( item.id )" class="extended-info"
                         :key="'ext-info-'+item.id">
                        <div>&nbsp;</div>
                        <div><span class="name">{{ item.name }}</span></div>
                        <div><span class="email">{{ item.email }}</span></div>
                    </div>
                    <div v-if="isAdmin && -1 < open.indexOf( item.id )" class="more-info" :key="'more-info-'+item.id">
                        <div>&nbsp;</div>
                        <div>{{ item.app_version }}</div>
                        <div><span class="remoteIp">{{ item.ip_address }}</span><br/>
                            <span class="reverseDns">{{ item.host_address }}</span></div>
                    </div>
                </transition-group>
            </div>
        </div>
    </div>
    <div v-else>
        <h1 class="headline wobble">Mitglieder</h1>
        <p class="content full"><strong>Hier</strong> findest Du normalerweise die Mitgliederliste mit zahlreichen Filtermöglichkeiten von <Lovepod/>.<br/><br/>
        Melde Dich an, um mehr zu sehen ;-)</p>
    </div>
</template>


<script>
import Username from "@/components/layout/parts/Username.vue";

export default {
    name: 'Members',
    components: { Username },
    data()
    {
        return {
            list:    [],
            open:    [],
            isAdmin: false
        }
    },
    
    mounted()
    {
        this.refresh()
    },
    
    methods: {
        refresh()
        {
            
            this.$core.getClient()
                .request( {
                    method: 'users.getAllMembers'
                } )
                .then( response =>
                {
                    
                    console.log( response )
                    this.list = response.result
                    if ( Array.isArray( response.result )
                         && response.result[ 0 ].email !== undefined ) {
                        this.isAdmin = true
                    }
                    
                } )
            
        },
        
        toggleInfo( id )
        {
            if ( -1 === this.open.indexOf( id ) ) {
                this.open.push( id )
            } else {
                this.$core.f().removeFromArray( this.open, id )
            }
        }
    }
}
</script>